const getFirstErrorMessage = (error: unknown): string | undefined => {
  if (typeof error === 'string') {
    const message = error.trim()
    return message || undefined
  }

  if (Array.isArray(error)) {
    for (const item of error) {
      const message = getFirstErrorMessage(item)
      if (message) return message
    }

    return undefined
  }

  if (typeof error === 'object' && error !== null && 'message' in error) {
    return getFirstErrorMessage(error.message)
  }

  return undefined
}

export { getFirstErrorMessage }
